import { Client } from "@/shared/api/client"

export class ManufacturerEpdDataService {

  clientService: Client

  constructor() {
    this.clientService = new Client();
  }

  list(manufacturerId: string, sourceType: string, productGroupId: string | null = null) {
    return this.clientService.makeRequest(`/functions/ListManufacturerEpdData`, {
      method: 'POST',
      content: { manufacturerId, sourceType, productGroupId },
    });
  }
}
